document.addEventListener("DOMContentLoaded", function () {
    const WORKER_URL = "https://instagram-feed-proxy.luis-74f.workers.dev";
    const container = document.querySelector(".instagram-carousel .slides");
    const prevButton = document.querySelector(".instagram-carousel .prev");
    const nextButton = document.querySelector(".instagram-carousel .next");

    if (!container) return;

    fetch(WORKER_URL)
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (!data.data || !data.data.length) {
                var section = container.closest(".instagram-carousel-section");
                if (section) section.style.display = "none";
                return;
            }

            var html = "";
            data.data.forEach(function (post) {
                if (post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM") {
                    html += '<div class="slide">' +
                        '<a href="' + post.permalink + '" target="_blank" rel="noopener">' +
                        '<img src="' + post.media_url + '" alt="' + (post.caption ? post.caption.substring(0, 80).replace(/"/g, "&quot;") : "Instagram Post") + '" loading="lazy" />' +
                        '</a></div>';
                } else if (post.media_type === "VIDEO") {
                    html += '<div class="slide">' +
                        '<a href="' + post.permalink + '" target="_blank" rel="noopener">' +
                        '<video src="' + post.media_url + '" poster="' + (post.thumbnail_url || "") + '" muted loop playsinline></video>' +
                        '</a></div>';
                }
            });

            container.innerHTML = html;
            initializeCarousel();
        })
        .catch(function (error) {
            console.error("Error fetching Instagram feed:", error);
            var section = container.closest(".instagram-carousel-section");
            if (section) section.style.display = "none";
        });
});

function initializeCarousel() {
    const slidesContainer = document.querySelector(".instagram-carousel .slides");
    const prevButton = document.querySelector(".instagram-carousel .prev");
    const nextButton = document.querySelector(".instagram-carousel .next");
    const isMobile = window.innerWidth <= 768;
    let index = 0;

    if (isMobile) {
        if (prevButton) prevButton.style.display = "none";
        if (nextButton) nextButton.style.display = "none";
        return;
    }

    const totalGroups = Math.ceil(slidesContainer.children.length / 4);

    function updateCarousel() {
        slidesContainer.style.transform = "translateX(" + (-index * 100) + "%)";
    }

    if (prevButton) {
        prevButton.addEventListener("click", function () {
            index = index > 0 ? index - 1 : totalGroups - 1;
            updateCarousel();
        });
    }

    if (nextButton) {
        nextButton.addEventListener("click", function () {
            index = index < totalGroups - 1 ? index + 1 : 0;
            updateCarousel();
        });
    }

    updateCarousel();
}
